var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_2686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.0003L3.08333 16.917C2.81944 17.1809 2.51736 17.2399 2.17708 17.0941C1.8368 16.9482 1.66667 16.6878 1.66667 16.3128V3.33366C1.66667 2.87533 1.82986 2.48296 2.15625 2.15658C2.48264 1.83019 2.875 1.66699 3.33333 1.66699H16.6667C17.125 1.66699 17.5174 1.83019 17.8438 2.15658C18.1701 2.48296 18.3333 2.87533 18.3333 3.33366V13.3337C18.3333 13.792 18.1701 14.1844 17.8438 14.5107C17.5174 14.8371 17.125 15.0003 16.6667 15.0003H5ZM6.66667 9.16699C6.90278 9.16699 7.10069 9.08713 7.26042 8.92741C7.42014 8.76769 7.5 8.56977 7.5 8.33366C7.5 8.09755 7.42014 7.89963 7.26042 7.73991C7.10069 7.58019 6.90278 7.50033 6.66667 7.50033C6.43056 7.50033 6.23264 7.58019 6.07292 7.73991C5.91319 7.89963 5.83333 8.09755 5.83333 8.33366C5.83333 8.56977 5.91319 8.76769 6.07292 8.92741C6.23264 9.08713 6.43056 9.16699 6.66667 9.16699ZM10 9.16699C10.2361 9.16699 10.434 9.08713 10.5938 8.92741C10.7535 8.76769 10.8333 8.56977 10.8333 8.33366C10.8333 8.09755 10.7535 7.89963 10.5938 7.73991C10.434 7.58019 10.2361 7.50033 10 7.50033C9.76389 7.50033 9.56597 7.58019 9.40625 7.73991C9.24653 7.89963 9.16667 8.09755 9.16667 8.33366C9.16667 8.56977 9.24653 8.76769 9.40625 8.92741C9.56597 9.08713 9.76389 9.16699 10 9.16699ZM13.3333 9.16699C13.5694 9.16699 13.7674 9.08713 13.9271 8.92741C14.0868 8.76769 14.1667 8.56977 14.1667 8.33366C14.1667 8.09755 14.0868 7.89963 13.9271 7.73991C13.7674 7.58019 13.5694 7.50033 13.3333 7.50033C13.0972 7.50033 12.8993 7.58019 12.7396 7.73991C12.5799 7.89963 12.5 8.09755 12.5 8.33366C12.5 8.56977 12.5799 8.76769 12.7396 8.92741C12.8993 9.08713 13.0972 9.16699 13.3333 9.16699Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmsBlue);
export default __webpack_public_path__ + "static/media/icon_sms_blue.07ea379aba17e4c16f8caf3a23f97ed1.svg";
export { ForwardRef as ReactComponent };